import Box from '@mui/material/Box';
import React from 'react';

import { sectionGridSx, fieldErrors } from './MainPartEdit.helpers';
import { MainPartEditTouched } from './MainPartEdit.props';
import { SizeProps } from '../../../@types';
import { PartObject } from '../../../@types/part.type';
import { PartType } from '../../../@types/partType.type';
import { Panel } from '../../atoms/Panel';
import { TextField } from '../../atoms/TextField';
import { EditFieldRow } from '../../molecules/EditFieldRow';
import { EditPartTypeLiveSearch } from '../../organisms/PartTypeSearchBox/EditPartTypeLiveSearch';

interface IdentitySectionProps {
  value: PartObject;
  partType: PartType;
  canEditSerial: boolean;
  canEditPartType: boolean;
  touched: MainPartEditTouched;
  validate: boolean;
  onChange: (value: PartObject) => void;
  onTouchSerial1: () => void;
  handlePartTypeChange: (value: { partTypeId: number }) => void;
}

export const IdentitySection: React.FC<IdentitySectionProps> = ({
  value,
  partType,
  canEditSerial,
  canEditPartType,
  touched,
  validate,
  onChange,
  onTouchSerial1,
  handlePartTypeChange,
}) => {
  const errors = fieldErrors(value, touched, validate);

  return (
    <Panel title="Identity">
      <Box sx={sectionGridSx}>
        <EditFieldRow label="Part Type" required fullWidth>
          <EditPartTypeLiveSearch
            partData={value}
            partTypeData={partType}
            isEditable={canEditPartType}
            handlePartTypeChange={handlePartTypeChange}
          />
        </EditFieldRow>
        <EditFieldRow
          label="Serial 1"
          required
          htmlFor="part-edit-serial1"
          helper={errors.serial1}
          error={Boolean(errors.serial1)}
        >
          <TextField
            disabled={!canEditSerial}
            fullWidth
            size={SizeProps.Small}
            label="Serial 1"
            value={value.serial1}
            error={Boolean(errors.serial1)}
            inputProps={{ id: 'part-edit-serial1' }}
            onChange={(serial1) => onChange({ ...value, serial1 })}
            onBlur={() => onTouchSerial1()}
          />
        </EditFieldRow>
        <EditFieldRow label="Serial 2" htmlFor="part-edit-serial2">
          <TextField
            disabled={!canEditSerial}
            fullWidth
            size={SizeProps.Small}
            label="Serial 2"
            value={value.serial2}
            inputProps={{ id: 'part-edit-serial2' }}
            onChange={(serial2) => onChange({ ...value, serial2 })}
          />
        </EditFieldRow>
        <EditFieldRow label="Serial 3" htmlFor="part-edit-serial3">
          <TextField
            disabled={!canEditSerial}
            fullWidth
            size={SizeProps.Small}
            label="Serial 3"
            value={value.serial3}
            inputProps={{ id: 'part-edit-serial3' }}
            onChange={(serial3) => onChange({ ...value, serial3 })}
          />
        </EditFieldRow>
      </Box>
    </Panel>
  );
};
